import { BoxProps, Loader as MantineLoader } from "@mantine/core";
import { CSSProperties } from "react";

import { Box } from "#shared/view/components/Box";

type Props = {
  color?: "blue" | "gray" | "violet" | "red" | "green" | "orange" | "yellow" | "pink" | "white";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  styles?: CSSProperties;
};

export const InlineLoader = ({
  size = "lg",
  color = "blue",
  styles,
  ...rest
}: Props & BoxProps) => {
  return (
    <Box style={Object.assign({}, containerStyles, styles)}>
      <MantineLoader size={size} color={color} {...rest} data-testid="inline-loader" />
    </Box>
  );
};

const containerStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
